let root = process.env.VUE_APP_BASE_API

// 入驻车队模块

const API_CONFIG = {
    fleetList: `/fleet/list`,
    fleetInfo: `/fleet/info`,
    cityList: `/car/cityList`, //城市列表
}

let apiProxy = new Proxy(API_CONFIG, {
    get: function (target, key) {
        return root + Reflect.get(target, key)    
    }
});

export default apiProxy